
import { defineComponent, nextTick, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { Mutations } from "@/store/enums/StoreEnums";
import { initializeComponents } from "@/core/plugins/keenthemes";

export default defineComponent({
  name: "app",
  setup() {
    const store = useStore();
    const alert = computed(() => store.getters.getAlert);
    watch(
      () => alert.value.show,
      (val) => {
        if (val === true) {
          setTimeout(() => {
            store.commit("setAlert", {
              message: "",
              subMessage: "",
              variant: "primary",
              duration: "",
              show: false,
            });
          }, alert.value.duration);
        }
      }
    );
    onMounted(() => {
      /**
       * this is to override the layout config using saved data from localStorage
       * remove this to use config only from static config (@/core/config/DefaultLayoutConfig.ts)
       */
      store.commit(Mutations.OVERRIDE_LAYOUT_CONFIG);

      nextTick(() => {
        initializeComponents();
      });
    });
    return{
      alert
    }
  },
});
